import { Home } from "./components/Home";
import { AORoutes } from "./components/AO/routes";
import { ActiviteRoutes } from "./components/Config/routes";
import { WordingRoutes } from "./components/Wording/routes"
import { CalculatedCvRoutes } from "./components/CalculatedCv/routes";
import { ConstantesConfigRoutes } from "./components/ConstantesConfig/routes";
import { MonitoringRoutes } from "./components/Monitoring/routes";
import { InfoRoutes } from "./components/Info/routes";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  ...AORoutes
    , ...ActiviteRoutes
    , ...WordingRoutes
    , ...CalculatedCvRoutes
    , ...ConstantesConfigRoutes
    , ...MonitoringRoutes
    ,...InfoRoutes
];

export default AppRoutes;
